import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ExportJobDto } from '~shared/types/export-job.dto'

import { queryKeys } from '~lib/constants/query'
import { ApiService } from '~lib/helpers/api'

export function useCreateExportJob(campaignId: string) {
  const queryClient = useQueryClient()

  const { mutateAsync: createExportJob, isPending: isCreatingExportJob } =
    useMutation({
      mutationFn: () =>
        ApiService.post<ExportJobDto>(
          `/campaigns/${campaignId}/distributions/exports`,
        ),
      onSuccess: async () => {
        await queryClient.invalidateQueries(
          queryKeys.exportJobs.list(campaignId),
        )
      },
    })

  return { createExportJob, isCreatingExportJob }
}
